import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { TrainingSessionTpl, emptyTrainingSessionTpl } from "../../../../interfaces/training-session-tpl";
import { getTrainingSessionTplSingle, updateTrainingSessionTpl } from "../../../../services/training-session-tpl";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionTplEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionTplEdit(props: CoachTrainingSessionTplEditProps) {
    const [trainingSessionTpl, setTrainingSessionTpl] = useState<TrainingSessionTpl>(emptyTrainingSessionTpl);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getTrainingSessionTplSingle(props.id)
            .then((response: any) => {
                setTrainingSessionTpl(response.data);
                setLoading(false);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            goals: event.target.goals.value,
        }
        updateTrainingSessionTpl(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="training-session-tpl-edit-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_training_session_tpl") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { loading && 
                    <LoadingSpinner />
                }
                { !loading && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Control type="hidden" name="id" required defaultValue={ trainingSessionTpl.id } />
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required defaultValue={ trainingSessionTpl.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea" rows={5} defaultValue={ trainingSessionTpl.description } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="goals">
                                <Form.Label>{ t("goals") }</Form.Label>
                                <Form.Control name="goals" as="textarea" rows={5} defaultValue={ trainingSessionTpl.goals } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}